import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { alignLeftCellStyle, alignCenterCellStyle, alignRightCellStyle } from '@common/cellStyles';
import AgGrid from '../../shared/agGrid/agGrid.component';
import { CustomDecimalRenderer } from '../../shared/numeralRenderers';
import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';

export const slDeferredBalancePropTypes = PropTypes.arrayOf(PropTypes.shape({
  TAX_YEAR: PropTypes.number,
  COMPANY_CODE: PropTypes.string,
  TRADING_PARTNER: PropTypes.string,
  COUNTRY_TAX_TYPE: PropTypes.string,
  SL_ACCOUNT: PropTypes.string,
  BOOK_TYPE: PropTypes.string,
  DESCRIPTION: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
  CURRENT_BALANCE: PropTypes.number,
  PROPOSED_ENTRY: PropTypes.number,
  NEW_BALANCE: PropTypes.number,
})).isRequired;

const baseColumnDefs = [
  { headerName: 'Tax Year', field: 'taxYear', minWidth: 80 },
  { headerName: 'Company Code', field: 'companyCode', minWidth: 120, ...alignCenterCellStyle },
  { headerName: 'Trading Partner', field: 'tradingPartner', minWidth: 120, ...alignCenterCellStyle },
  { headerName: 'Country Code', field: 'countryCode', minWidth: 90 },
  { headerName: 'Country Tax Type', field: 'countryTaxType', minWidth: 90 },
  { headerName: 'Subledger Account', field: 'slAccount', minWidth: 120, ...alignLeftCellStyle },
  { headerName: 'Book Type', field: 'bookType', minWidth: 50, ...alignCenterCellStyle },
  { headerName: 'Account', field: 'description', minWidth: 120, ...alignLeftCellStyle },
  { headerName: 'Currency', field: 'currencyCode', minWidth: 80, ...alignCenterCellStyle },
  { headerName: 'Net Current Balance', field: 'currentNetBalance', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
  { headerName: 'Net Proposed Entry', field: 'proposedNetEntry', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
  { headerName: 'Net New Balance*', field: 'newNetBalance', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
];

const grossColumnDefs = [
  { headerName: 'Gross Current Balance', field: 'currentGrossBalance', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
  { headerName: 'Gross Proposed Entry', field: 'proposedGrossEntry', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
  { headerName: 'Gross New Balance*', field: 'newGrossBalance', cellRenderer: CustomDecimalRenderer, minWidth: 100, ...alignRightCellStyle },
];

const getColumnDefs = (allowGross = false) => [
  ...baseColumnDefs,
  ...(allowGross ? grossColumnDefs : []),
];

class ProposedSubledgerBalanceGrid extends PureComponent {
  static propTypes = {
    slDeferredBalance: slDeferredBalancePropTypes,
    allowGross: PropTypes.bool,
    onGridReady: PropTypes.func,
  };

  static defaultProps = {
    allowGross: false,
  };

  onGridReady = params => {
    if (this.props.onGridReady) {
      this.props.onGridReady(params);
    }
  };

  render() {
    const { slDeferredBalance, allowGross } = this.props;

    const columnDefinitions = getColumnDefs(allowGross);

    const slDeferredBalanceWithDecodedTaxTypes = slDeferredBalance.map(row => {
      const { countryCode, countryTaxType } = decodeCountryTaxType(row.countryTaxType);

      return {
        ...row,
        countryCode,
        countryTaxType,
      };
    });

    return (
      <div className="proposed-subledger-balance-grid">
        <div className="ag-theme-bootstrap">
          <AgGrid
            columnDefs={columnDefinitions}
            headerHeight={50}
            domLayout="autoHeight"
            rowData={slDeferredBalanceWithDecodedTaxTypes}
            onGridReady={this.onGridReady}
          />
          <div className="row">
            <div className="col">
              <div className="float-right">
                *Proposed subledger balances only include approved subledger tax entries.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProposedSubledgerBalanceGrid;
